import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Tabs, Tab } from 'react-bootstrap';
import { Message } from '../Message';
import QueryString from 'query-string';
import i18next from 'i18next';
import { PageTitle } from '../PageTitle';
import { ScrollModule } from '../ScrollModule';
import ScrollArea from 'react-scrollbar';
import { RolesService } from '../../services';
import RoleList from './roles_list';
import SSOMapping from './sso_mapping';
import * as actions from '../../actions/user_actions';

const Roles = ({ history, location, me }) => {
  const [localErrorMessage, setLocalErrorMessage] = useState(null);
  const [roleTypes, setRoleTypes] = useState(history.location?.state?.roleTypes);
  const [selectedRoleType, setSelectedRoleType] = useState(history.location?.state?.selectedRoleType);

  const parsedOptions = useMemo(() => QueryString.parse(location.search), [location]);
  const ssoMappingSelected = useMemo(() => history.location?.state?.ssoMapping || parsedOptions["ssoMapping"] == "true", [parsedOptions, history]);

  useEffect(() => {
    if (roleTypes == null) {
      RolesService.getAllRoleTypes().then((response) => {
        const roleTypes = response.roleTypes.filter((type) => type.token != "responsibility_role");
        const selectedRoleType = roleTypes.filter((type) => type.token == parsedOptions["selectedRoleType"]);
        
        setRoleTypes(roleTypes);
        setSelectedRoleType(selectedRoleType.length > 0 ? selectedRoleType[0] : null);
      })
      .catch((error) => {
          console.error(error);
          setLocalErrorMessage(i18next.t("messages.could-not-load-roles"));
      });
    }
  }, []);

  useEffect(() => {
    if (roleTypes != null) {
      const selectedRoleType = roleTypes.filter((type) => type.token == parsedOptions["selectedRoleType"]);
      setSelectedRoleType(selectedRoleType.length > 0 ? selectedRoleType[0] : null);
    }
  }, [parsedOptions]);

  const handleSelect = useCallback((key) => {
    if (key == 99) {
      history.push({
        search: '?ssoMapping=true',
        state: { ssoMapping: true, selectedRoleType: null, roleTypes: roleTypes }
      });
    } else {
      setSelectedRoleType(roleTypes.find(roleType => roleType.id === key));
    }
  }, [roleTypes]);

  if (roleTypes) {
    const defaultActiveKey = ssoMappingSelected ? 99 : (selectedRoleType ? selectedRoleType.id : roleTypes[0].id);
    const roleType = ssoMappingSelected ? null : (!selectedRoleType ? roleTypes[0] : selectedRoleType);

    return (
      <div className="animated fadeIn">
        <div className="row">
          {
            roleType == null ?
              <PageTitle title={i18next.t('pages.roles.header')} /> :
              <PageTitle title={i18next.t('pages.roles.header')}
                  addLinkWithParams={{ link: { pathname: "/admin/roles/add", roleType: roleType, state: { backLinkSearch: location.search} } } } 
              />
          }           
        </div>

        { localErrorMessage && <Message errorMessage={localErrorMessage} messageDismissCallback={() => setLocalErrorMessage(null)} /> }
        { location.state?.errorMessage && <Message errorMessage={location.state.errorMessage} /> }
        { location.state?.successMessage && <Message successMessage={location.state.successMessage} /> }

        <div className="op-content-box">
          <ScrollModule/>
          <ScrollArea speed={0.8} className="scroll-container" contentClassName="scrollable-content" horizontal={true} >
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="card-block">

                    <Tabs className="role-tabs" id="tabs" onSelect={handleSelect} defaultActiveKey={defaultActiveKey} mountOnEnter={true}>
                      {
                        roleTypes.map(roleType => {
                          return (
                              <Tab key={roleType.id} eventKey={roleType.id} title={i18next.t(`role-types.${roleType.token}`)}>
                                <RoleList
                                  roleType={roleType}
                                  roleTypes={roleTypes}
                                  selectedRoleType={selectedRoleType}
                                  currLocation={history.location}
                                  currSearch={location.search}
                                  pushHistory={(params) => history.push(params)}
                                />
                              </Tab>
                          )
                        })
                      }

                      {
                        (me.enterprise?.ssoEnabled ?? false) &&
                          <Tab key={99} eventKey={99} title="SSO Mapping">
                            <SSOMapping roleTypes={roleTypes} enterpriseId={me.enterprise.id} />
                          </Tab>
                      }
                    </Tabs>

                  </div>
                </div>
              </div>
            </div>
          </ScrollArea>
        </div>

      </div>
    );
  } else {
    return <div className="loader">{i18next.t("loading")}</div>;      
  }
};

export default connect(({ user }) => ({ me: user.me }), actions)(Roles);
